/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/103-redo': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 9a7.982 7.982 0 002.709 6l1.323-1.5a6 6 0 118.212-8.743L10.001 7h6V1l-2.343 2.343A8 8 0 00.001 9z"/>'
  }
})
